import React, { memo } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from '@heroui/react';
import { useTranslation } from 'react-i18next';

const GuideBuilderNotFound: React.FC = memo(() => {
  const { t } = useTranslation('admin');

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-gray-200 rounded-xl mx-auto mb-4 flex items-center justify-center">
          <AlertTriangle className="w-8 h-8 text-gray-400" />
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">{t('guides.builder.notFound.title')}</h2>
        <p className="text-gray-600 mb-6">{t('guides.builder.notFound.description')}</p>
        <Button color="primary" onPress={handleGoBack} startContent={<RefreshCw className="w-4 h-4" />}>
          {t('guides.builder.notFound.goBack')}
        </Button>
      </div>
    </div>
  );
});

GuideBuilderNotFound.displayName = 'GuideBuilderNotFound';

export default GuideBuilderNotFound;
